import { html } from 'lit';
import { property, query } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { ToggleEvents } from '../types';
import { FormFieldInput } from '../../gzForm/formField/component/FormFieldInput';

export class GzToggleWebComponent extends FormFieldInput<boolean> {
  @property({ type: Boolean, reflect: true })
  checked = false;

  @property({ type: Boolean, reflect: true })
  stopEmitEvents = false;

  @property({ type: Boolean, reflect: true })
  smallSize = false;

  @query('input')
  protected checkbox!: HTMLInputElement;

  public setFormValue(value: boolean): void {
    if (!this.checkbox) {
      this.checked = value;
      return;
    }

    this.checkbox.checked = value;
    this.handleChange(null);
  }

  public getFormValue(): boolean {
    return this.checked;
  }

  public setEnabled(isEnabled: boolean): void {
    this.disabled = !isEnabled;
  }

  // see https://lit-element.polymer-project.org/guide/styles
  static get styles() {
    return styles;
  }

  render() {
    return html`
      <label class="toggle-button">
        <span class="toggle-bar">
          <input
            type="checkbox"
            .checked="${this.checked}"
            ?disabled="${this.disabled}"
            ?readonly="${this.readonly}"
            @click="${this.handleClick}"
            @change="${this.handleChange}"
          />
          <span class="toggle-thumb"></span>
        </span>
        <span class="toggle-label"><slot></slot></span>
      </label>
    `;
  }

  private handleChange(e) {
    this.updateCheckboxStates();
    if (e || !this.stopEmitEvents) {
      this.emitCheckboxChangeEvent();
    }
  }

  private handleClick(e) {
    if (this.readonly) {
      e.preventDefault();
    }
  }

  private updateCheckboxStates() {
    /**
     * Get the checked and indeterminate states from the native input and update the component properties to reflect
     * the UI changes
     */
    const { checked } = this.checkbox;
    this.checked = checked;
  }

  private emitCheckboxChangeEvent() {
    /**
     * Emit the change event with element details
     */
    const { checked } = this.checkbox;
    const changeEvent = new CustomEvent(ToggleEvents.TOGGLE_CHANGE, {
      detail: {
        checked,
      },
      bubbles: true,
      composed: true,
    });
    this.dispatchEvent(changeEvent);
  }
}
